<template>
  <div class="add-payment-auth">
    <CategoryTitle :category="category" />
    <div>
      <!-- id: 12 monetaweb, 13 monetawebpaypal -->
      <TigrosPaymentTypeList
        :modality="'addAuth'"
        :options="paymentTypeListOptions"
        :filteredPaymentTypeIds="config.addAuthPaymentTypeIds"
      />
    </div>
  </div>
</template>
<script>
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import TigrosPaymentTypeList from "@/components/payment/TigrosPaymentTypeList.vue";

import categoryMixins from "~/mixins/category";

export default {
  name: "MyPaymentMethods",
  mixins: [categoryMixins],
  components: {
    TigrosPaymentTypeList,
    CategoryTitle
  },
  data() {
    return {
      config: null,
      paymentAuthList: [],
      paymentTypeListOptions: {
        flatPanels: true,
        showCardLogos: true,
        hidePrevButton: true,
        showRememberCard: false,
        showAddNewCardWarning: false
      }
    };
  },
  created() {
    this.config = global.config;
  }
};
</script>
